import React from "react";
import { FilterChipProps } from "./FilterChip.types";
import { ChipContainer, ChipIcon, IconWrapper } from "./FilterChip.styles";
import {
  Body5MediumTypography,
  Body5RegularTypography,
} from "../../primitives/Typography/typographyVariants";

export const FilterChip: React.FC<FilterChipProps> = ({
  id,
  label,
  isSelected = false,
  isDisabled = false,
  selectedCount,
  leftIcon,
  rightIcon,
  onClick,
  onLeftIconClick,
  onRightIconClick,
  dataCy,
  leftIconColor,
  rightIconColor,
}) => {
  const handleChipClick = () => {
    if (!isDisabled && onClick) {
      onClick(); // Call external onClick function if provided
    }
  };
  const handleLeftIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isDisabled && onLeftIconClick) onLeftIconClick();
  };

  const handleRightIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isDisabled && onRightIconClick) onRightIconClick();
  };

  const displayLabel =
    isSelected && selectedCount && selectedCount > 0
      ? `${label} (${selectedCount})`
      : label;

  return (
    <ChipContainer
      id={id}
      data-cy={dataCy}
      isSelected={isSelected}
      disabled={isDisabled}
      onClick={handleChipClick}
    >
      {leftIcon && (
        <IconWrapper
          isDisabled={isDisabled}
          isSelected={isSelected}
          onClick={onLeftIconClick ? handleLeftIconClick : undefined}
        >
          <ChipIcon className={leftIcon} color={leftIconColor} />
        </IconWrapper>
      )}
      {isSelected ? (
        <Body5MediumTypography>{displayLabel}</Body5MediumTypography>
      ) : (
        <Body5RegularTypography>{displayLabel}</Body5RegularTypography>
      )}
      {rightIcon && (
        <IconWrapper
          isDisabled={isDisabled}
          isSelected={isSelected}
          onClick={onRightIconClick ? handleRightIconClick : undefined}
        >
          <ChipIcon className={rightIcon} color={rightIconColor} />
        </IconWrapper>
      )}
    </ChipContainer>
  );
};

export default FilterChip;
